"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const typedownQueryKey = path => {
  const keyArray = ['stripes-kint-components', 'typedown'];
  if (path) {
    keyArray.push(path);
  }
  return keyArray;
};
var _default = exports.default = typedownQueryKey;